import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Button } from '@mui/material';
import { Root, classes } from './utils';
import { lightPalette } from '../../../../theme';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import subscriberColumnData from './subscriberColumnDef';
import invitedSubscriberColumnDef from './invitedSubscriberColumnDef';
import { globalClasses } from '../../utils/globalUtils';
import AddOrganization from './AddOrganization';
import {
  subscriberDetails,
  invitedSubscriberDetails,
  salesSubscriberDetails,
} from '../../../../services/subscriberDetails';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';
import { getLocalStorageItem } from '../../../../services/localStorageUtils';
import ROLES from '../../../../constants/roles';

const Subscriber = () => {
  const [open, setOpen] = useState(false);
  const [gridSettingData, setGridSettingData] = useState({});
  const [showCurrentSubscriberTable, setShowCurrentSubscriberTable] =
    useState(true);
  const [showInvitedSubscriberTable, setShowInvitedSubscriberTable] =
    useState(false);
  const loginRole = getLocalStorageItem('role');

  const handleTableButton = () => {
    setShowCurrentSubscriberTable(true);
    setShowInvitedSubscriberTable(false);
  };

  const handleChartButton = () => {
    setShowCurrentSubscriberTable(false);
    setShowInvitedSubscriberTable(true);
  };

  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('subscriber-detail');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);
  const getSubscription = async (sorting, inputValue, filterModel) => {
    if (loginRole === ROLES.SALES_ADMIN || loginRole === ROLES.SALES) {
      const result = await salesSubscriberDetails(
        sorting,
        inputValue,
        filterModel,
      );
      return result;
    }
    const result = await subscriberDetails(sorting, inputValue, filterModel);
    return result;
  };
  return (
    <Root className={classes.root}>
      <Box className={classes.mainBox}>
        <Box className={classes.titleMainBox}>
          <Backdrop className={globalClasses.backdrop} open={open}>
            <AddOrganization setOpen={setOpen} />
          </Backdrop>
        </Box>
        <Box className={classes.Table_Chart_Button_Box}>
          <Box className={classes.Table_Chart_Button_Inner_wrapped_Box}>
            <Button
              className={classes.Table_Chart_Button}
              onClick={handleTableButton}
              variant={showCurrentSubscriberTable ? 'contained' : 'text'}
              sx={{
                background: showCurrentSubscriberTable
                  ? lightPalette.japanBlush.main
                  : null,
                color: showCurrentSubscriberTable
                  ? lightPalette.darkPurple.main
                  : lightPalette.lunarBase.main,
                ':hover': {
                  background: showCurrentSubscriberTable
                    ? lightPalette.japanBlush.main
                    : null,
                  color: showCurrentSubscriberTable
                    ? lightPalette.darkPurple.main
                    : lightPalette.lunarBase.main,
                },
              }}
            >
              Current
            </Button>
            <Button
              className={classes.Table_Chart_Button}
              onClick={handleChartButton}
              variant={showInvitedSubscriberTable ? 'contained' : 'text'}
              sx={{
                background: showInvitedSubscriberTable
                  ? lightPalette.japanBlush.main
                  : null,
                color: showInvitedSubscriberTable
                  ? lightPalette.darkPurple.main
                  : lightPalette.lunarBase.main,
                ':hover': {
                  background: showInvitedSubscriberTable
                    ? lightPalette.japanBlush.main
                    : null,
                  color: showInvitedSubscriberTable
                    ? lightPalette.darkPurple.main
                    : lightPalette.lunarBase.main,
                },
              }}
            >
              Invited
            </Button>
          </Box>
        </Box>
        {showCurrentSubscriberTable && (
          <AgGrid
            TitleHeader="Subscriber Details"
            className={classes.subscriberOverviewAgGridStyle}
            columnData={subscriberColumnData}
            getRowData={getSubscription}
            gridSettingData={gridSettingData}
            gridKey="subscriber-detail"
            setOpen={setOpen}
            setGridSettingData={setGridSettingData}
          />
        )}
        {showInvitedSubscriberTable && (
          <AgGrid
            TitleHeader="Invited Subscriber Details"
            className={classes.subscriberOverviewAgGridStyle}
            columnData={invitedSubscriberColumnDef}
            getRowData={invitedSubscriberDetails}
            gridKey="invited-subscriber-detail"
            setOpen={setOpen}
          />
        )}
      </Box>
    </Root>
  );
};

export default Subscriber;
